import { IsWorker } from "@pdfking/compatibility"
import create_app from "./create_app"

// esbuild might be packaging this code in a worker env, which results in window being undefined
// since any of this code is used, we simply drop the initialization of virtual components

export default app => {
  if (!app.render) app.render = () => null // disable vue warning for missing render function
  if (!IsWorker() && typeof document !== "undefined")
    // @ts-expect-error partial options for virtual component
    return create_app({
      app,
      el: document.createElement("div"),
    })
}
